export default class LeadGenerationApi {
  [x: string]: any;

  static $inject = ['LeadGenerationProjectsService'];

  constructor(LeadGenerationProjectsService) {
    this.LeadGenerationProjectsService = LeadGenerationProjectsService;
  }

  // getLeadGenerationProjectNames(projectId: number) {
  //   return this.LeadGenerationProjectsService.findProjectNamesForCrazyCallProject(projectId);
  // }

}
